var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { DataGrid } from '../elements/data-grid';
import { DataGridCell } from '../elements/data-grid-cell';
import { DataGridRow } from '../elements/data-grid-row';
import { DataGridHeadCell } from '../elements/data-grid-head-cell';
import { MarkdownContent } from '../elements/markdown-content';
import { useLang } from '../hooks/use-lang';
import { includes } from 'lodash';
import { EntityValue } from './entity-value';
import { ContentNode } from './content-node';
import { useManagement } from '../hooks/use-management';
var cls = classNames('entity-data-grid');
export var EntityDataGridDefaultProps = {
  items: [],
  showFoot: true
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    max-height: 60vh;\n  "], ["\n    max-height: 60vh;\n  "])))
});
var CellStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var RowStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    &:last-child {\n      border-bottom: none;\n    }\n  "], ["\n    &:last-child {\n      border-bottom: none;\n    }\n  "])))
});
var TooltipContentStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var EntityMultiValueStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    user-select: none;\n    h2 {\n      white-space: nowrap;\n    }\n\n    margin-bottom: ", ";\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n  "], ["\n    user-select: none;\n    h2 {\n      white-space: nowrap;\n    }\n\n    margin-bottom: ", ";\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n  "])), theme.UNIT(4))
});
var EntityValueStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    user-select: none;\n    h2 {\n      white-space: nowrap;\n    }\n  "], ["\n    user-select: none;\n    h2 {\n      white-space: nowrap;\n    }\n  "])))
});
var ContentStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    ", "\n    user-select: none;\n  "], ["\n    ", "\n    user-select: none;\n  "])), function (_a) {
    var isEmpty = _a.isEmpty;
    return isEmpty && css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), theme.COLOR('text-very-subtle'));
  })
});
var FootContentStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    display: flex;\n    margin-top: 2px;\n    padding-left: 2px;\n    font-weight: 500;\n    color: inherit;\n  "], ["\n    display: flex;\n    margin-top: 2px;\n    padding-left: 2px;\n    font-weight: 500;\n    color: inherit;\n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'EntityDataGrid',
  Container: styled(DataGrid)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Row: styled(DataGridRow)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), RowStyles),
  Cell: styled(DataGridCell)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), CellStyles),
  HeadCell: styled(DataGridHeadCell)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), CellStyles),
  Content: styled(ContentNode)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles),
  EntityValue: styled(EntityValue)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), EntityValueStyles),
  EntityMultiValue: styled(EntityValue)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), EntityMultiValueStyles),
  TooltipContent: styled(MarkdownContent)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), TooltipContentStyles),
  FootContent: styled.span(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), FootContentStyles)
};
export var EntityDataGrid = function (props) {
  var componentProps = useComponentProps(My.NAME, EntityDataGridDefaultProps, props);
  var className = componentProps.className,
    items = componentProps.items,
    defn = componentProps.defn,
    showFoot = componentProps.showFoot,
    showBorder = componentProps.showBorder;
  var manage = useManagement();
  var t = useLang();
  return React.createElement(My.Container, {
    showBorder: showBorder,
    className: cls.name(className),
    head: defn.formFields.map(function (field, index) {
      var description = manage.isOwn ? field.ownDescription || field.description : field.description;
      return React.createElement(My.HeadCell, {
        isLast: index === defn.formFields.length - 1,
        id: field.name,
        key: index,
        tooltip: description && React.createElement(My.TooltipContent, {
          text: description
        })
      }, field.label);
    }),
    footOnClick: function () {},
    footColSpan: defn.formFields.length,
    foot: showFoot && React.createElement(My.FootContent, null, t(items.length ? "".concat(defn.createAnotherLabel || 'Add More', " ...") : "".concat(defn.createLabel || 'Add', " ...")))
  }, items.map(function (item, index) {
    return React.createElement(My.Row, {
      key: index
    }, defn.formFields.map(function (field, index) {
      var itemDictionary = item;
      var value = itemDictionary[field.name];
      var isLogo = includes(['Organisation'], field.entityTypeName);
      return value && React.createElement(My.Cell, {
        isLast: index === defn.formFields.length - 1,
        key: index
      }, field.type === 'linked' && React.createElement(My.EntityValue, {
        showImageBorder: isLogo,
        imageStyle: isLogo ? 'logo' : 'default',
        variant: 'card',
        entity: value
      }), field.type === 'linkedMultiple' && value.length && value.map(function (item) {
        return React.createElement(My.EntityMultiValue, {
          showImageBorder: isLogo,
          imageStyle: isLogo ? 'logo' : 'default',
          variant: 'card',
          entity: item
        });
      }), field.type === 'longText' && React.createElement(My.Content, {
        isEmpty: !(value === null || value === void 0 ? void 0 : value.text),
        entity: (value === null || value === void 0 ? void 0 : value.text) ? value : {
          text: '(none)'
        }
      }), field.formFieldType === 'boolean' && (value ? t('Yes') : t('No')));
    }));
  }));
};
EntityDataGrid.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18;